module.exports = __webpack_public_path__ + "img/au.622ba887.svg";